<script lang="ts" setup>
import Link2 from '@/components/Button/Link2.vue'
import Link6 from '@/components/Button/Link6.vue'
import { PageApi } from '@/utils/api'
import useSeo from './seo_search'

const route = useRoute()
const api = new PageApi()
const res = ref<any>({})
const searchText = ref(route.query.q as string || '')
const listsIndex = ref(0)
const lists = ref([
  {
    id: 0,
    title: '全部類別'
  },
  {
    id: 1,
    title: '文章'
  },
  {
    id: 2,
    title: '活動'
  },
  {
    id: 3,
    title: '常見問題'
  }
])

const toUrl = (item: any) => {
  if (item.cat === 'articleProject') {
    return `/hence/article/${item.id}`
  } else if (item.cat === 'articleBlog') {
    return `/blog/article/${item.id}`
  } else if (item.cat === 'articleBrand') {
    return `/brand/${item.id}`
  } else if (item.cat === 'articleNews') {
    return `/news/article/${item.id}`
  } else if (item.cat === 'articleEcolife') {
    return `/sustainability/articles/${item.id}`
  } else if (item.cat === 'articleFaq') {
    return `/services/faq/${item.id}`
  } else if (item.cat === 'articleMagazine') {
    return `/hence/magazine`
  } else if (item.cat === 'articleRecipe') {
    return `/hence/recipe/article/${item.id}`
  } else {
    if (item.model_type === 'App\\Models\\Event') {
      return `/events/${item.id}`
    }
  }
  //  else if (item.cat === 'articleReport') {
  //   return `/faq/${item.id}`
  // } else if (item.cat === 'articleMagazine') {
  //   return `/faq/${item.id}`
  // }
}

const toCategory = (item: any) => {
  if (item.cat === 'articleFaq') {
    return {
      id: 3,
      title: '常見問題'
    }
  } else if (item.model_type === 'App\\Models\\Event') {
    return {
      id: 2,
      title: '活動'
    }
  } else {
    return {
      id: 1,
      title: '文章'
    }
  }
  //  else if (item.cat === 'articleReport') {
  //   return `/faq/${item.id}`
  // } else if (item.cat === 'articleMagazine') {
  //   return `/faq/${item.id}`
  // }
}

const clear = () => {
  searchText.value = ''
  listsIndex.value = 0
  res.value = {}
}

const handleChangePage = async (page: number) => {
  const f = {
    q: searchText.value,
    type: listsIndex.value ?? '',
    page,
  }
  res.value = await api.getSearch(f)
  useSeo(searchText.value, res.value?.meta?.total || 0)
}

const enterKeyword = () => {
  handleChangePage(1)
  navigateTo(`/search?q=${searchText.value}`)
}
if (route.query.q) {
  handleChangePage(1)
}

watch(
  () => listsIndex.value,
  () => {
    res.value = {}
    handleChangePage(1)
  }
)

watch(
  () => route.query.q,
  (v) => {
    searchText.value = v as string || ''
    handleChangePage(1)
  }
)
</script>

<template>
  <section class="search">
    <div class="search__inner">
      <!-- <div class="search__placeholder" v-show="placeholderShow">
        <div class="search__placeholder__en">search</div>
        <div class="search__placeholder__tw">關鍵字搜尋</div>
      </div> -->
      <div class="search__inputBox">
        <input type="text" v-model="searchText" class="search__input" placeholder="search"
          @keyup.enter.parent="enterKeyword" />
        <div class="search__icon" @click="enterKeyword">
          <svg-icon name="icon-arrow-right" />
        </div>
      </div>
      <div class="search__bottom">
        <ul class="search__category" :class="{ isSearch: searchText !== '' }">
          <li v-for="(item, index) in lists" :key="index" :class="{ active: index === listsIndex }"
            @click="listsIndex = index">
            {{ item.title }}
          </li>
        </ul>
        <Link6 icon="icon-close" linkTitle="取消搜尋" @click="clear" class="cursor-pointer search__btnClose" />
      </div>

      <div class="search-result" v-if="searchText !== ''">
        <div class="search-result__topTitle">
          搜尋關鍵字 {{ searchText }} ，共找到了 {{ res?.meta?.total || 0 }} 筆相關結果
        </div>
        <ul class="search-result__lists">
          <li v-for="(item, index) in res.data" :key="item.id" :class="`color${toCategory(item).id}`">
            <div class="search-result__item">
              <nuxt-link :to="toUrl(item)" class="search-result__pic">
                <Nimg :src="item.image?.link" :alt="item.image?.alt" :title="item.image?.title" />
              </nuxt-link>
              <div class="search-result__right">
                <div class="search-result__category">{{ toCategory(item).title }}</div>
                <nuxt-link :to="toUrl(item)" class="search-result__title">
                  {{ item.subject }}
                </nuxt-link>
              </div>
              <div class="search-result__link">
                <Link2 :to="toUrl(item)" class="circle search-result__link" />
              </div>
            </div>
          </li>
        </ul>
        <div class="search__pagination">
          <Pagination2 class="h-pagination center" layout="prev, pager, next" :page-meta="res.meta"
            :handleChangePage="handleChangePage" />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.search {
  @include grid;

  @include max-media(990) {
    @include grid(4, 24);
  }

  &__inner {
    position: relative;
    grid-column: 3 / span 8;

    @include max-media(990) {
      grid-column: 1 / span 4;
    }
  }

  &__btnClose {
    @include max-media(640) {
      :deep(.link__title) {
        font-size: toRem(14);
      }

      :deep(.link__icon) {
        width: toRem(32);
        height: toRem(32);
      }
    }
  }

  &__placeholder {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    color: $color-gray-3;

    &__en {
      margin-right: toRem(24);
      font-size: toRem(60);
      font-family: $font-TextaAlt;
      font-weight: 500;
      line-height: 0.8;
      letter-spacing: toRem(-1.2);
    }

    &__tw {
      font-size: toRem(28);
      font-weight: 500;
      line-height: 1.3;
    }
  }

  &__inputBox {
    position: relative;
    width: 100%;
    margin-bottom: toRem(25);
    border-bottom: 1px solid $color-gray-line;
  }

  &__input {
    width: 100%;
    height: toRem(100);
    padding-right: toRem(60);
    padding-top: toRem(24);
    padding-bottom: toRem(24);
    background: none;
    border: none;
    font-family: $font-Noto;
    color: $color-black-1;
    font-size: toRem(28);
    font-weight: 500;
    line-height: 1.3;

    @include max-media(640) {
      font-size: toRem(20);
      height: toRem(76);
    }

    &::placeholder {
      font-family: $font-TextaAlt;
      font-weight: 500;
      font-size: toRem(60);
      color: $color-gray-3;

      @include max-media(640) {
        font-size: toRem(34);
      }
    }

    &:focus {
      outline: none;
    }
  }

  &__icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: toRem(54);
    height: toRem(54);
    color: $color-brand-3;
    cursor: pointer;

    @include max-media(640) {
      width: toRem(24);
      height: toRem(24);
    }
  }

  &__bottom {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    @include max-media(640) {
      flex-direction: column;
    }
  }

  &__category {
    display: flex;
    flex-wrap: wrap;

    @include max-media(640) {
      margin-bottom: toRem(24);
    }

    &.isSearch {
      li {
        &.active {
          background-color: $color-brand-3;
        }
      }
    }

    li {
      margin-right: toRem(12);
      font-size: toRem(16);
      line-height: 1.45;
      color: $color-gray-1;
      padding: toRem(12) toRem(24);
      border-radius: toRem(3);
      cursor: pointer;
      transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);

      @include max-media(640) {
        padding: toRem(12) toRem(16);
        font-size: toRem(14);
      }

      &.active {
        background-color: $color-gray-3;
        color: $color-white-1;
      }
    }
  }

  &__pagination {
    padding-top: toRem(105);
  }
}

.search-result {
  padding-top: toRem(74);

  @include max-media(640) {
    padding-top: toRem(32);
  }

  li {
    &:not(:last-child) {
      margin-bottom: toRem(24);
    }
  }

  .color1 {
    .search-result {

      &__category,
      &__link {
        color: $color-brand-3;

        :deep(svg) {
          color: $color-brand-3;
        }
      }
    }
  }

  .color2 {
    .search-result {

      &__category,
      &__link {
        color: $color-brand-4_1;

        :deep(svg) {
          color: $color-brand-4_1;
        }
      }
    }
  }

  .color3 {
    .search-result {

      &__category,
      &__link {
        color: $color-gray-1;

        :deep(svg) {
          color: $color-gray-1;
        }
      }
    }
  }

  &__topTitle {
    margin-bottom: toRem(24);
    font-size: toRem(16);
    font-weight: 400;
    line-height: 1.45;
    color: $color-gray-1;
  }

  &__item {
    display: flex;
    border-radius: toRem(5);
    background-color: $color-white-1;
  }

  &__pic {
    position: relative;
    display: block;
    width: 26%;
    padding-top: 15%;

    @include max-media(480) {
      display: none;
    }

    img {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 66%;
    padding: toRem(24) toRem(24) toRem(24) toRem(32);

    @include max-media(480) {
      width: 100%;
      padding: toRem(24);
    }
  }

  &__category {
    display: block;
    margin-bottom: toRem(4);
    font-size: toRem(14);
    font-weight: 700;
    line-height: 1.3;
  }

  &__title {
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.4;
    color: $color-black-1;
    @include dot-many-line(2);

    @include max-media(640) {
      @include dot-many-line(3);
    }
  }

  &__link {
    display: flex;
    align-items: center;
    width: toRem(64);
    flex-shrink: 0;

    @include max-media(640) {
      display: none;
    }
  }
}
</style>
